import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '../../../core/components/base/base.component';
import { FeedbackService } from '../../../core/services/feedback.service';
import { patientReportedLabel, withPatientReported } from '../../../core/utils/patient-reported';

@Component({
  selector: 'app-medication-list-creator',
  templateUrl: './medication-list-creator.component.html',
  styleUrls: ['./medication-list-creator.component.scss']
})
export class MedicationListCreatorComponent extends BaseComponent implements OnChanges {
  /** The "Patient reported" mark of a row the patient gave (their invite, or the patient app). */
  readonly reported = patientReportedLabel;

  @Input() heading: string = 'Medication';
  @Input() medications: any[] = [];
  @Input() noMedication: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() hideCheckbox: boolean = false;
  @Output() medicationChanged = new EventEmitter<any[]>();
  @Output() noMedicationChanged = new EventEmitter<boolean>();

  editingMedication: any = {};

  @ViewChild('addMedicationDialog') addMedicationDialog?: TemplateRef<any>;

  constructor(fs: FeedbackService, md: MatDialog) {
    super(fs, md);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['medications'] && this.medications.length > 0) {
      this.noMedication = false;
    }
  }

  openAddMedicationDialog(): void {
    this.noMedication = false;
    this.editingMedication = { id: this.medications.length + 1 };
    this.dialog.open(this.addMedicationDialog!);
  }

  getTooltipText(medication: any): string {
    return withPatientReported(`Dosage: ${medication.dosage || 'Not Provided'}`, medication);
  }

  editMedication(medication: any): void {
    this.editingMedication = { ...medication };
    this.dialog.open(this.addMedicationDialog!);
  }

  saveMedication(): void {
    if (!this.editingMedication.medication) return;
    const index = this.medications.findIndex(c => c.id === this.editingMedication.id);
    if (index !== -1) {
      this.medications[index] = this.editingMedication;
    } else {
      this.medications.push(this.editingMedication);
    }
    this.emitHistory();
    this.dialog.closeAll();
  }


  cancelEdit(): void {
    this.dialog.closeAll();
  }

  removeMedication(item: any): void {
    const index = this.medications.indexOf(item);
    if (index !== -1) {
      this.medications.splice(index, 1);
      this.emitHistory();
    }
  }

  toggleNoMedication(): void {
    this.noMedicationChanged.emit(this.noMedication);
    if (this.noMedication) {
      this.medicationChanged.emit([]);
    } else {
      this.emitHistory();
    }
  }

  private emitHistory(): void {
    const emittedList = this.medications.map(item => {
      if (typeof item.id === 'number') {
        const { id, ...rest } = item;
        return rest;
      }
      return item;
    });
    this.medicationChanged.emit(emittedList);
  }
}